<template>
    <div>
        <home-top></home-top>
        <home-scenarios></home-scenarios>
        <!--home-brief></home-brief -->
        <home-solutions></home-solutions>
        <home-services></home-services>
        <home-procedure></home-procedure>
        <home-careers></home-careers>
    </div>
</template>
<script>
import HomeTop from "./components/HomeTop"
import HomeBrief from "./components/HomeBrief"
import HomeScenarios from "./components/HomeScenarios"
import HomeSolutions from "./components/HomeSolutions"
import HomeServices from "./components/HomeServices"
import HomeProcedure from "./components/HomeProcedure"
import HomeCareers from "./components/HomeCareers"

export default {
  name: "components",
  components: {
    HomeTop,
    HomeBrief,
    HomeScenarios,
    HomeSolutions,
    HomeServices,
    HomeProcedure,
    HomeCareers
  }
};
</script>
